import { Get, Post } from "./ApiBase";

// PR-472-FIX (Jeremy review): explicit 240s (4-minute) timeout on the upload
// call. Mirrors the backend's HttpClient ceiling (TimeSpan.FromMinutes(4)
// in ResumeParser.cs) so the front-to-back contract is symmetric and we
// don't inherit browser-default behavior (Chrome ~5min, Firefox ~5min, iOS
// Safari shorter & unpredictable). The frontend's own Promise.race in
// AIUpload.vue is the UI-level backstop; axios is the underlying network
// ceiling.
const UPLOAD_TIMEOUT_MS = 240000;

export async function UploadResume(file) {
  return await Post("/api/UploadAndParseResume", file, {
    timeout: UPLOAD_TIMEOUT_MS
  });
}

// PR-ASYNC-PARSE: poll an async parse job. When async mode is on, UploadResume
// returns { data: { jobId, async: true } } immediately and the worker parses
// off the SWA gateway; the frontend calls this until status is "done"
// (navigate with data.resumeId) or "failed" (show data.displayText).
export async function GetParseStatus(jobId) {
  return await Get(`/api/GetParseStatus?jobId=${encodeURIComponent(jobId)}`);
}
